var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 831,
    viewBox: "0 0 562 831",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8827_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.999 823L35.5 406L521.5 413.5L281.999 823Z",
    fill: "#62ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 277C558 429.983 433.983 554 281 554C128.017 554 4 429.983 4 277C4 124.017 128.017 0 281 0C433.983 0 558 124.017 558 277Z",
    fill: "#62ADEF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8827_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.912 147.5C324.826 147.5 341.757 159.233 348.398 176.943L383.095 269.47C411.333 274.58 432.75 299.288 432.75 329C432.75 362.413 405.663 389.5 372.25 389.5C338.837 389.5 311.75 362.413 311.75 329C311.75 302.779 328.43 280.455 351.759 272.059L344.751 253.372L239.312 292.912C246.812 302.987 251.25 315.475 251.25 329C251.25 362.413 224.163 389.5 190.75 389.5C157.337 389.5 130.25 362.413 130.25 329C130.25 296.6 155.72 270.147 187.73 268.574L191.094 268.502L174.288 238.25H160.5C152.147 238.25 145.375 231.478 145.375 223.125C145.375 214.772 152.147 208 160.5 208H221C229.353 208 236.125 214.772 236.125 223.125C236.125 231.478 229.353 238.25 221 238.25H208.893L224.415 266.19L334.13 225.048L320.073 187.564C317.86 181.661 312.216 177.75 305.912 177.75H266.375C258.021 177.75 251.25 170.978 251.25 162.625C251.25 154.272 258.021 147.5 266.375 147.5H305.912ZM374.778 298.854L371.964 298.752C355.389 298.904 342 312.388 342 329C342 345.707 355.543 359.25 372.25 359.25C388.957 359.25 402.5 345.707 402.5 329C402.5 313.145 390.302 300.139 374.778 298.854ZM190.75 298.75C174.043 298.75 160.5 312.293 160.5 329C160.5 345.707 174.043 359.25 190.75 359.25C207.457 359.25 221 345.707 221 329C221 312.293 207.457 298.75 190.75 298.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8827_3450",
    x: 0,
    y: 0,
    width: 562,
    height: 831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8827_3450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8827_3450",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8827_3450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 363,
    height: 363,
    fill: "white",
    transform: "translate(100 87)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.318fb9b324fbe15d0466263a68a91710.svg";
export { ForwardRef as ReactComponent };